import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AcervoSections from "@/components/AcervoSections";
import FeaturedContent from "@/components/FeaturedContent";
import Footer from "@/components/Footer";
import { ContainerScroll } from "@/components/ContainerScroll";
import directorImage from "@/assets/jorge-fons-directing.jpeg";

const Index = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <div className="below-fold">
        <AcervoSections />
        <ContainerScroll titleComponent={<div />}>
          <img
            src={directorImage}
            alt="Jorge Fons en el set de filmación"
            className="w-full h-full object-cover"
          />
        </ContainerScroll>
        <FeaturedContent />
      </div>
      <Footer />
    </div>
  );
};

export default Index;
